import styled from 'styled-components';
import theme from '../../styles/defaultTheme';

export const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 0 24px 0;
    width: 100%;

    @media(max-width: 850px) {
        margin: 0 0 16px 0;
    }

    & > label {
        display: flex;
        font-size: ${theme.font.size16};
        align-items: center;
        margin: 0 0 8px 0;
        color: ${(props) => props.theme.grey};

        @media(min-width: 621px) {
            white-space: nowrap;
        }

        & .material-icon {
            margin: 0 0 0 8px;
        }
    }

    & input, 
    & select, 
    & textarea,
    & input::placeholder {
        color: ${(props) => props.theme.black};
    }

    & input[disabled], 
    & select[disabled], 
    & textarea[disabled] {
        background-color: ${(props) => props.theme.disabledGrey10};
        cursor: not-allowed;
    }

    & .MuiIconButton-root:hover {
        background: transparent;
    }

    & .ant-picker-clear {
        color: ${(props) => props.theme.lightGrey40};
        font-size: ${theme.font.size18};
        margin-right: 1px;
    }
`;

export const ContainerHelp = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const SpanError = styled.span`
    color: ${(props) => props.theme.red};
    font-size: ${theme.font.size12};
    margin-top: 4px;
    padding-left: 2px;
`;

export const EmptyField = styled.div`
    height: 98px;

    @media(max-width: 850px) {
        display: none;
    }
`;

export const ContainerOptions = styled.div`
    width: 100%;
    max-height: 270px;
    overflow-y: auto;
    position: absolute;
    border: 1px solid ${(props) => props.theme.lightGreyLink40};
    box-shadow: rgb(0 0 0 / 20%) 0px 5px 5px -3px, rgb(0 0 0 / 14%) 0px 8px 10px 1px, rgb(0 0 0 / 12%) 0px 3px 14px 2px;
    background: ${(props) => props.theme.white};
    border-radius: 8px;

    ${({ isOnFocus }) => !isOnFocus && `display: none;`}

    ${({ optionsPosition }) => optionsPosition && `top: ${optionsPosition}px;`}

    z-index: 1000;

    & > div {
        padding: 0 16px;
        margin: 16px 0 24px 0;

        & label { 
            margin: 0;
        }
    }

    & ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    & li {
        display: flex;
        align-items: center;
        transition: 0.2s;
        font-size: ${theme.font.size16};
        padding: 8px 16px;

        &:hover {
            background: ${(props) => props.theme.hoverOrangeTransparent};
            cursor: pointer;
        }

        &.group-name {
            font-weight: bold;
            padding: 8px 12px;
        }

        &.no-data-found {
            opacity: 0.7;
        }

        & .MuiSvgIcon-root {
            font-size: ${theme.font.size17};
            margin-right: 10px;
        }
    }
`;
